import { useState } from 'react';

import { Button } from '@/components/ui/button';

import ViewDialog from '../ViewDialog';

const DocumentRow = ({ document }) => {
  const [open, setIsOpen] = useState(false);

  return (
    <>
      <div key={document.id} className="flex justify-between items-center">
        <span className="inline-block">{document.name}</span>
        <Button variant="outline" size="sm" onClick={() => setIsOpen(true)}>
          View
        </Button>
      </div>
      {open && (
        <ViewDialog document={document} open={open} setIsOpen={setIsOpen} />
      )}
    </>
  );
};

export default DocumentRow;
